import { render, staticRenderFns } from "./ReviewDetail.vue?vue&type=template&id=f9e2572e&scoped=true"
import script from "./ReviewDetail.vue?vue&type=script&lang=ts"
export * from "./ReviewDetail.vue?vue&type=script&lang=ts"
import style0 from "./ReviewDetail.vue?vue&type=style&index=0&id=f9e2572e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e2572e",
  null
  
)

export default component.exports